"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToYears = exports.formatCurrency = exports.formatRemove = void 0;
require("@rmlibrary/canvas-player-controls");
var html_pdf_1 = require("@rmlibrary/html-pdf");
var canvas_player_1 = require("@rmlibrary/canvas-player");
var utilities_1 = require("./utilities");
var custom_elements_1 = require("@rmlibrary/custom-elements");
var logic_1 = require("./logic");
var animation_1 = require("./animation");
var pdf_1 = require("./pdf");
var language = (0, utilities_1.getLanguage)();
var devicePixelRatio = (0, utilities_1.getDevicePixelRatio)();
var container = document.querySelector(".cp-container");
var pdfRef = document.querySelector("rm-html-pdf");
var testPDF = document.getElementById("previewPDF");
var userInputVals;
var videoURLPrefix = "../common/videos/";
var playerControls = document.getElementsByTagName("rm-canvas-player-controls")[0];
var formatRemove = function (val) { return val.replace(/[^0-9.-]/g, ""); };
exports.formatRemove = formatRemove;
var formatCurrency = function (val, decimalPlaces) {
    var removedFormatting = +(0, exports.formatRemove)(val);
    var formattedNumber = removedFormatting.toLocaleString("en-CA", {
        style: "currency",
        currency: "CAD",
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    });
    return formattedNumber;
};
exports.formatCurrency = formatCurrency;
var convertToYears = function (percentToIncrease) {
    var inputVals = (0, logic_1.getInputVals)();
    var monthlySavings = Number(inputVals.monthlySavings) * (1 + percentToIncrease);
    var currentSavings = Number(inputVals.currentSavings);
    var savingsGoal = Number(inputVals.goal);
    var goalTime = Math.ceil((savingsGoal - currentSavings) / monthlySavings);
    var golTimeTxt = String(goalTime);
    if (goalTime / 24 > 1) {
        golTimeTxt =
            goalTime % 12 > 0
                ? Math.floor(goalTime / 12) + " years, " + (goalTime % 12) + " months"
                : Math.floor(goalTime / 12) + " years";
    }
    else {
        golTimeTxt = golTimeTxt + " months";
    }
    return golTimeTxt;
};
exports.convertToYears = convertToYears;
// testPDF?.addEventListener("click", () => {
//     setupPDF();
//     const pdf = htmlToPDF.generate(pdfRef, {});
//     pdf.doc.save("Primerica - Pay Yourself First.pdf");
// });
var RMDynamicVideo = /** @class */ (function (_super) {
    __extends(RMDynamicVideo, _super);
    function RMDynamicVideo() {
        var _this = this;
        _this.embedMode = false;
        _this.ready = false;
        // @ts-ignore
        return _this = _super.call(this) || this;
    }
    RMDynamicVideo.prototype.connectedCallback = function () {
        this.container = document.getElementsByClassName("cp-container")[0];
        this.controls = document.getElementsByTagName("rm-canvas-player-controls")[0];
        this.largePlayButton = document.getElementsByClassName("cp-large-play")[0];
        this.pauseButton = document.getElementsByClassName("cp-pause")[0];
        this.playButton = document.getElementsByClassName("cp-play")[0];
        this.replayButton = document.getElementsByClassName("cp-replay")[0];
        this.videoElem = document.getElementsByClassName("cp-video")[0];
    };
    RMDynamicVideo.prototype.disconnectedCallback = function () {
        var _a, _b;
        (_a = this.controls) === null || _a === void 0 ? void 0 : _a.removeEventListeners();
        (_b = this.player) === null || _b === void 0 ? void 0 : _b.destroy();
    };
    RMDynamicVideo.prototype.initVideo = function (data, embedMode) {
        var _this = this;
        var _a;
        this.embedMode = embedMode;
        this.stageVars = data;
        var activeElem = document.querySelector(".cp-video");
        activeElem.src = videoURLPrefix + language + "/" + "S3-how-does-it-work.mp4";
        (0, animation_1.loadAnimations)(data.timeline).then(function (animations) { return _this.handleLoadedAnimations(animations); });
        (_a = this.videoElem) === null || _a === void 0 ? void 0 : _a.pause();
    };
    RMDynamicVideo.prototype.updateAnimationTimeline = function (animations, startScene) {
        var _a, _b;
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.reflow(animations, {
            scene: startScene
        });
        //
        (_b = this.player) === null || _b === void 0 ? void 0 : _b.play();
        this.largePlayButton.classList.add("hide");
        this.pauseButton.classList.remove("hide");
        this.playButton.classList.add("hide");
        this.replayButton.classList.add("hide");
    };
    RMDynamicVideo.prototype.playVideo = function () {
        var _this = this;
        if (this.player && this.ready) {
            setTimeout(function () {
                var _a, _b;
                (_a = _this.player) === null || _a === void 0 ? void 0 : _a.play();
                (_b = _this.largePlayButton) === null || _b === void 0 ? void 0 : _b.classList.add("hide");
            }, 100);
        }
    };
    RMDynamicVideo.prototype.resetVideo = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.pause();
        (_b = this.player) === null || _b === void 0 ? void 0 : _b.goToFrame(0);
        (_c = this.largePlayButton) === null || _c === void 0 ? void 0 : _c.classList.remove("hide");
        (_d = this.pauseButton) === null || _d === void 0 ? void 0 : _d.classList.add("hide");
        (_e = this.playButton) === null || _e === void 0 ? void 0 : _e.classList.remove("hide");
        (_f = this.replayButton) === null || _f === void 0 ? void 0 : _f.classList.add("hide");
        var clipsToReset = ((_g = this.stageVars) === null || _g === void 0 ? void 0 : _g.clipsToReset) || [];
        while (clipsToReset.length) {
            var instance = clipsToReset.pop();
            instance.isSingleFrame = false;
        }
    };
    RMDynamicVideo.prototype.updateVideoData = function (data) {
        var _a;
        (_a = this.player) === null || _a === void 0 ? void 0 : _a.updateStageVars(data);
        if (this.controls) {
            userInputVals = (0, logic_1.getInputVals)();
            this.controls.formatTranscript = this.formatTranscript(userInputVals);
        }
        this.updateTranscript();
    };
    RMDynamicVideo.prototype.convertToYears = function (percentToIncrease) {
        return (0, exports.convertToYears)(percentToIncrease);
    };
    // TODO: Modify method to replace static tokens with dynamic values for captions and descriptions.
    RMDynamicVideo.prototype.formatTranscript = function (_userInput) {
        var _this = this;
        return function (text) {
            var formattedText = "";
            if (text) {
                formattedText = text
                    .replace(/\[goal_amount\]/gi, (0, exports.formatCurrency)(_userInput.goal, 0))
                    .replace(/\[current_savings\]/gi, (0, exports.formatCurrency)(_userInput.currentSavings, 0))
                    .replace(/\[monthly_savings\]/gi, (0, exports.formatCurrency)(_userInput.monthlySavings, 0))
                    .replace(/\[goal_meet_time\]/gi, _userInput.normalTime)
                    .replace(/\[monthly_savings_plus10\]/gi, (0, exports.formatCurrency)(_userInput.monthlySavings10, 0))
                    .replace(/\[goal_meet_time_plus10\]/gi, _userInput.time10)
                    .replace(/\[monthly_savings_plus20\]/gi, (0, exports.formatCurrency)(_userInput.monthlySavings20, 0))
                    .replace(/\[goal_meet_time_plus20\]/gi, _userInput.time20)
                    .replace(/\[goal_meet_time_callOut\]/gi, _this.convertToYears(0))
                    .replace(/\[goal_meet_time_plus10_callOut\]/gi, _this.convertToYears(0.1))
                    .replace(/\[goal_meet_time_plus20_callOut\]/gi, _this.convertToYears(0.2));
            }
            return formattedText;
        };
    };
    RMDynamicVideo.prototype.loadBgMusic = function (src) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var queue = new createjs.LoadQueue(true);
            queue.installPlugin(createjs.Sound);
            queue.on("complete", function () {
                var _a;
                try {
                    var inst = createjs.Sound.play("bgMusic", { loop: -1 });
                    inst.paused = true;
                    //if player is already playing, start the sound
                    if (!((_a = _this.player) === null || _a === void 0 ? void 0 : _a.paused)) {
                        inst.paused = false;
                    }
                    resolve(inst);
                }
                catch (e) {
                    reject(e);
                }
            });
            queue.on("error", function (e) {
                reject(new Error(e.message));
            });
            queue.loadFile({ id: "bgMusic", src: src });
        });
    };
    RMDynamicVideo.prototype.handleLoadedAnimations = function (animations) {
        var _this = this;
        var _a, _b;
        var overlay = null;
        var bgSound;
        var hidden = "";
        var replaying = false;
        var isScrubbing = false;
        var videoObjs = {
            videoIntro: videoURLPrefix + language + "/S3-how-does-it-work.mp4"
        };
        this.player = new canvas_player_1.default(this.container, animations, {
            autoplay: false,
            domOverlay: true,
            backgroundMusic: {
                fadeOut: true,
                // TODO: Update soundClipID when the background music has been added to the first Animate file in the timeline.
                soundClipID: ""
            },
            nativeAudio: true,
            dynamicTimeline: animations.map(function (animation) { return animation.meta.TITLE; }),
            // TODO: Set enableCC to true when captions and descriptions have been added to the Animate files.
            enableCC: true,
            // TODO: Update fonts for client.
            fonts: ["Open sans"],
            pixelDensity: devicePixelRatio,
            rootName: "",
            stageVars: __assign(__assign({}, this.stageVars), { getVideoToPlay: function (sceneName) {
                    playerControls.getElementsByClassName("cp-controls-container")[0].classList.remove("hidden");
                    var videoFound = false;
                    isScrubbing = false;
                    for (var i = 0; i < Object.keys(videoObjs).length; i++) {
                        var value = Object.values(videoObjs)[i];
                        if (value.includes(sceneName)) {
                            videoFound = true;
                            return value;
                        }
                    }
                    if (!videoFound) {
                        console.log("no video path for *".concat(sceneName, "*, check animate video name matches video name in videos folder"));
                    }
                }, setCurrentName: function (mcInstance) {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    if (mcInstance && mcInstance.userName)
                        mcInstance.userName.text = _this.inputVals.name + ",";
                }, setCurrentNameBg: function (mcInstance) {
                    var scaleX = Math.round((mcInstance.userName.getBounds().width / 370) * 100) / 100;
                    if (scaleX == 0.8)
                        mcInstance.userNameBg.scaleX = scaleX + 0.05;
                    else
                        mcInstance.userNameBg.scaleX = scaleX;
                }, setSavingsGoal: function (mcInstance) {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    if (mcInstance && mcInstance.savingsGoal)
                        mcInstance.savingsGoal.text = (0, exports.formatCurrency)(_this.inputVals.goal, 0);
                }, getSavingsGoal: function () {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    return (0, exports.formatCurrency)(_this.inputVals.goal, 0);
                }, getCurrentName: function () {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    return _this.inputVals.name + ",";
                }, getCurrentSavings: function () {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    return (0, exports.formatCurrency)(_this.inputVals.currentSavings, 0);
                }, getMonthlySavings: function () {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    return (0, exports.formatCurrency)(_this.inputVals.monthlySavings, 0);
                }, getMonthlySavings10: function () {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    return (0, exports.formatCurrency)(String(_this.inputVals.monthlySavings10), 0);
                }, getMonthlySavings20: function () {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    return (0, exports.formatCurrency)(String(_this.inputVals.monthlySavings20), 0);
                }, getMonthsToReachGoal: function () {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    return _this.inputVals.normalTime;
                }, getMonthsToReachGoalTxt: function () {
                    return _this.convertToYears(0);
                }, getMonthsToReachGoalCalenderTxt: function (_mc) {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    var goalTime = Number(_this.inputVals.normalTime);
                    var golTimeTxt = String(goalTime);
                    var goalTimeYears = Math.floor(goalTime / 12);
                    if (goalTime / 24 > 1) {
                        if (goalTime % 12 > 1)
                            golTimeTxt =
                                goalTimeYears > 1
                                    ? "years, " + (goalTime % 12) + " months"
                                    : "year, " + (goalTime % 12) + " months";
                        else if (goalTime % 12 == 1)
                            golTimeTxt =
                                goalTimeYears > 1
                                    ? "years, " + (goalTime % 12) + " month"
                                    : "year, " + (goalTime % 12) + " month";
                        else
                            golTimeTxt = goalTimeYears > 1 ? "years" : "year";
                        if (typeof _mc != "undefined" && goalTime % 12 > 0) {
                            if (_mc.name == "calendarArt")
                                _mc.regX = _mc.regX + 190;
                            if (_mc.name == "goalReachingTime") {
                                _mc.x = _mc.x - 200;
                            }
                        }
                        return [goalTimeYears, golTimeTxt];
                    }
                    else {
                        golTimeTxt = goalTime > 1 ? "months" : "month";
                        return [goalTime, golTimeTxt];
                    }
                }, getMonthsToReachGoalPercent: function (percentToIncrease) {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    var monthlySavings = Number(_this.inputVals.monthlySavings) * (1 + percentToIncrease);
                    var currentSavings = Number(_this.inputVals.currentSavings);
                    var savingsGoal = Number(_this.inputVals.goal);
                    var goalTime = Math.ceil((savingsGoal - currentSavings) / monthlySavings);
                    return goalTime;
                }, getMonthsToReachGoalPercentTxt: function (percentToIncrease) {
                    return _this.convertToYears(percentToIncrease);
                }, getLegendTickNumber: function (totalMonths, totalLegendTicks, legendNumber) {
                    if (totalMonths < 5 && legendNumber != 5)
                        return "";
                    var _roundedMonths = Math.ceil(totalMonths / 6) * 6;
                    return (_roundedMonths / totalLegendTicks) * legendNumber;
                }, convertGoalToK: function () {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    if (_this.inputVals.goal < 1000)
                        return _this.inputVals.goal.toString();
                    return "".concat(parseFloat((_this.inputVals.goal / 1000).toFixed(1)), "k");
                }, convertCurrSavingsToK: function () {
                    _this.inputVals = (0, logic_1.getInputVals)();
                    if (_this.inputVals.currentSavings < 1000)
                        return _this.inputVals.currentSavings.toString();
                    return "".concat(parseFloat((_this.inputVals.currentSavings / 1000).toFixed(1)), "k");
                }, updateScaleXBasedOnName: function (nameWidth) {
                    return nameWidth / 500;
                }, updateScaleXBasedOnName2: function (nameWidth) {
                    return nameWidth / 450;
                }, resetStageVars: function (_targetP, _targetB) {
                    $(".cp-large-replay").trigger("click");
                    //reset bgsound
                    replaying = false;
                    bgSound.position = 0;
                    bgSound.volume = 1;
                    bgSound.paused = false;
                    _this.largePlayButton.classList.add("hide");
                    _this.playButton.classList.add("hide");
                    playerControls.getElementsByClassName("cp-controls-container")[0].classList.remove("hidden");
                    //ensure playbutton overlay is hidden on replay, allow background clicks
                    setTimeout(function () {
                        _this.playButton.classList.add("hide");
                        _this.largePlayButton.classList.add("hide");
                        _this.container.style.pointerEvents = "auto";
                    }, 500);
                }, generatePDF: function (_targetP, _targetB) {
                    (0, pdf_1.setupPDF)();
                    var pdf = html_pdf_1.default.generate(pdfRef, {});
                    pdf.doc.save("Primerica - Pay Yourself First.pdf");
                } })
        });
        this.player.on("canplay", function () {
            var canvas = document.getElementsByTagName("canvas")[0];
            canvas.style.backgroundColor = "white";
            _this.updateTranscript();
            _this.ready = true;
            if (_this.embedMode) {
                parent.postMessage({ type: "video_ready" }, location.origin);
            }
        });
        if (this.controls) {
            userInputVals = (0, logic_1.getInputVals)();
            this.controls.formatTranscript = this.formatTranscript(userInputVals);
        }
        (_a = this.controls) === null || _a === void 0 ? void 0 : _a.toggleIndicators(true);
        (_b = this.controls) === null || _b === void 0 ? void 0 : _b.attachCanvasPlayer(this.player);
        //focus listner to stop BG Music when the tab goes out of focus
        var addFocusListener = function (listener) {
            var visibilityChange = "";
            if (typeof document.hidden !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                hidden = "hidden";
                visibilityChange = "visibilitychange";
            }
            else if (typeof document.msHidden !== "undefined") {
                hidden = "msHidden";
                visibilityChange = "msvisibilitychange";
            }
            else if (typeof document.webkitHidden !== "undefined") {
                hidden = "webkitHidden";
                visibilityChange = "webkitvisibilitychange";
            }
            if (typeof document.addEventListener === "undefined" || typeof document.hidden === "undefined") {
                console.warn("focus/blur changes on tab require Google Chrome or Firefox");
            }
            else {
                document.addEventListener(visibilityChange, listener, false);
            }
        };
        Promise.all([this.loadBgMusic(videoURLPrefix + language + "/background.mp3")]).then(function (_a) {
            var bgSoundInstance = _a[0];
            bgSound = bgSoundInstance;
            var wasBgSound = false;
            var wasVideoPlaying = false;
            var videoLoading = false;
            _this.player.on("play", function () {
                _this.largePlayButton.classList.add("hide");
                if (bgSound.paused) {
                    bgSound.paused = false;
                }
                if (!overlay) {
                    overlay = container.querySelector(".cp-overlay");
                }
                overlay.style.pointerEvents = "none";
            });
            _this.player.on("pause", function () {
                if (!bgSound.paused && !replaying) {
                    bgSound.paused = true;
                }
            });
            addFocusListener(function () {
                var _a, _b;
                if (document.hidden) {
                    if (!bgSound.paused) {
                        wasBgSound = true;
                        bgSound.paused = true;
                    }
                    if ((_a = _this.currentScene) === null || _a === void 0 ? void 0 : _a.isVideo) {
                        wasVideoPlaying = !_this.videoElem.paused;
                        _this.videoElem.pause();
                    }
                }
                else {
                    if (wasBgSound) {
                        bgSound.paused = false;
                        wasBgSound = false;
                    }
                    if (wasVideoPlaying) {
                        _this.videoElem.play();
                        (_b = _this.player) === null || _b === void 0 ? void 0 : _b.play();
                        wasVideoPlaying = false;
                    }
                }
            });
        });
    };
    RMDynamicVideo.prototype.updateTranscript = function () {
        var _a, _b, _c;
        var descriptions = ((_a = this.player) === null || _a === void 0 ? void 0 : _a.generateTranscript()) || [];
        var sanitizedDescriptions = (0, utilities_1.sanitizeDescriptions)(descriptions, (_b = this.controls) === null || _b === void 0 ? void 0 : _b.formatTranscript);
        var htmlURL = "".concat(i18n("transcript"), ".html");
        (_c = this.controls) === null || _c === void 0 ? void 0 : _c.updateTranscript((0, utilities_1.buildTranscriptHTML)(sanitizedDescriptions), "#transcript-body", htmlURL);
    };
    return RMDynamicVideo;
}(custom_elements_1.HTMLCustomElement));
(0, custom_elements_1.registerElement)("rm-dynamic-video", RMDynamicVideo);
exports.default = RMDynamicVideo;
//# sourceMappingURL=module.js.map